import React from 'react';
import { GridSortModel } from 'utils/types';

const useGridSort = (
  initialSort: Array<GridSortModel>, // Initial sort array
  defaultSort?: GridSortModel, // Initial sort value
) => {
  const [currentSort, setCurrentSort] = React.useState<
    GridSortModel | null | undefined
  >(null);

  /**
   * Function to update currentSort state based on the provided sortBy field
   * @param sortBy - The field to sort by (e.g., "openDate", "amount")
   */
  const updateSortBy = (sortBy: string) => {
    const sortItem = initialSort?.find(item => item.sortBy === sortBy);

    if (sortItem && currentSort?.sortOrder !== 'desc') {
      // Check if currentSort already has the same sortBy value
      if (currentSort?.sortBy === sortBy) {
        // Toggle sortOrder between 'asc' and 'desc'
        const toggledSortOrder =
          currentSort.sortOrder === 'asc' ? 'desc' : 'asc';
        setCurrentSort({ ...currentSort, sortOrder: toggledSortOrder });
      } else {
        // Set to the new sortItem with its defined order (defaulting to 'asc')
        setCurrentSort(sortItem);
      }
    } else {
      // If sortItem is not found in initialSort, reset to undefined
      setCurrentSort(undefined);
    }
  };

  React.useEffect(() => {
    setCurrentSort(defaultSort ?? undefined); // Set initial sort value
  }, []);

  return { currentSort, setCurrentSort, updateSortBy };
};

export default useGridSort;
